export const organizationQueryKey = (orgId: string | null) => ['getClientById', orgId] as const;